module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tag":"Video interview","title":"Camera setup","namePlaceholder":"Enter your name","enterWithVideo":"Enter with video","enterWithoutVideo":"Enter without video","requestingCamera":"Requesting camera access...","noCamera":"No camera found","connecting":"Connecting..."}}')
  delete Component.options._Ctor
}
